import { render } from "./StartAssessmentPage.vue?vue&type=template&id=ab8e66d2&scoped=true"
import script from "./StartAssessmentPage.vue?vue&type=script&lang=js"
export * from "./StartAssessmentPage.vue?vue&type=script&lang=js"

import "./StartAssessmentPage.vue?vue&type=style&index=0&id=ab8e66d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8e66d2"]])

export default __exports__